

(function(){
  // tabs
  document.addEventListener('click', function(e){
    const tabBtn = e.target.closest('[data-size-tabs] .sc-tab');
    if(!tabBtn) return;

    const wrap = tabBtn.closest('[data-size-tabs]');
    const key = tabBtn.getAttribute('data-tab');
    if(!wrap || !key) return;

    wrap.querySelectorAll('.sc-tab').forEach(btn=>{
      const active = btn === tabBtn;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    wrap.querySelectorAll('.sc-panel').forEach(panel=>{
      panel.classList.toggle('is-active', panel.getAttribute('data-panel') === key);
    });
  });

  // unit toggle per block (women/men/kids/pets independently)
  document.addEventListener('click', function(e){
    const btn = e.target.closest('button[data-unit-toggle]');
    if(!btn) return;

    const block = btn.closest('[data-sc]');
    if(!block) return;

    block.classList.toggle('unit-inch');
    const isInch = block.classList.contains('unit-inch');
    btn.textContent = isInch ? 'Switch to Cm' : 'Switch to Inch';
  });
})();
